import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import lottie from 'lottie-web';
import styles from './LottiePlayer.module.scss';
export function LottiePlayerInner(param) {
    let { animationData, path, loop = false, autoplay = false, initialSegment, onComplete, onDOMLoaded, width, height, className, style, testId } = param;
    const containerRef = useRef(null);
    const onCompleteRef = useRef(onComplete);
    const onDOMLoadedRef = useRef(onDOMLoaded);
    // eslint-disable-next-line custom/no-useref-for-prop-mirror -- latest-callback ref: a changing onComplete identity must NOT reload the animation (event-callback pattern)
    onCompleteRef.current = onComplete;
    // eslint-disable-next-line custom/no-useref-for-prop-mirror -- latest-callback ref (see above)
    onDOMLoadedRef.current = onDOMLoaded;
    useEffect(()=>{
        if (!containerRef.current) return;
        const animationInstance = lottie.loadAnimation(_object_spread({
            container: containerRef.current,
            renderer: 'svg',
            loop,
            autoplay
        }, animationData ? {
            animationData
        } : {}, path ? {
            path
        } : {}, initialSegment ? {
            initialSegment
        } : {}));
        const handleComplete = ()=>{
            var _onCompleteRef_current;
            return (_onCompleteRef_current = onCompleteRef.current) === null || _onCompleteRef_current === void 0 ? void 0 : _onCompleteRef_current.call(onCompleteRef);
        };
        const handleDOMLoaded = ()=>{
            var _onDOMLoadedRef_current;
            return (_onDOMLoadedRef_current = onDOMLoadedRef.current) === null || _onDOMLoadedRef_current === void 0 ? void 0 : _onDOMLoadedRef_current.call(onDOMLoadedRef);
        };
        animationInstance.addEventListener('complete', handleComplete);
        animationInstance.addEventListener('DOMLoaded', handleDOMLoaded);
        return ()=>{
            animationInstance.destroy();
        };
    }, [
        animationData,
        path,
        loop,
        autoplay,
        initialSegment
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: cn(styles.root, className),
        style: _object_spread({}, width != null ? {
            width
        } : {}, height != null ? {
            height
        } : {}, style),
        "data-testid": testId
    });
}
